module.exports = __webpack_public_path__ + "media/images/client-logos/client-logo_ba-5690806a45945307e8bf582c76106a50.png";